import { render, staticRenderFns } from "./tab-items.vue?vue&type=template&id=4cbc13bc&"
import script from "./tab-items.vue?vue&type=script&lang=ts&"
export * from "./tab-items.vue?vue&type=script&lang=ts&"
import style0 from "./tab-items.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports